/**
 * Gate cart checkout until 21+ / legal consent is checked.
 * Covers cart drawer + /cart; does not modify Shopify checkout pages.
 */
(function () {
  var STORAGE_KEY = 'wd_cart_consent_v1';
  var debounceTimer = null;

  function isCheckoutPath(href) {
    if (!href) return false;
    try {
      var url = new URL(href, window.location.origin);
      return /\/checkout(\/|$|\?)/.test(url.pathname) || url.pathname.indexOf('/checkouts/') !== -1;
    } catch (e) {
      return /\/checkout/i.test(String(href));
    }
  }

  function getStored() {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setStored(on) {
    try {
      if (on) sessionStorage.setItem(STORAGE_KEY, '1');
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function findCtas(from) {
    return from && from.closest ? from.closest('.cart__ctas') : null;
  }

  function consentCheckedIn(ctas) {
    if (!ctas) return false;
    var input = ctas.querySelector('[data-wd-cart-consent-input]');
    return !!(input && input.checked);
  }

  function anyConsentChecked() {
    var inputs = document.querySelectorAll('[data-wd-cart-consent-input]');
    if (!inputs.length) return getStored();
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) return true;
    }
    return false;
  }

  function showHint(ctas) {
    var scope = ctas || document.querySelector('.cart__ctas');
    if (!scope) return;
    var hint = scope.querySelector('[data-wd-cart-consent-hint]');
    if (hint) {
      hint.hidden = false;
      hint.classList.add('is-visible');
    }
    var wrap = scope.querySelector('[data-wd-cart-consent]');
    if (wrap) wrap.classList.add('wd-cart-consent--error');
  }

  function clearHint(ctas) {
    if (!ctas) return;
    var hint = ctas.querySelector('[data-wd-cart-consent-hint]');
    if (hint) {
      hint.hidden = true;
      hint.classList.remove('is-visible');
    }
    var wrap = ctas.querySelector('[data-wd-cart-consent]');
    if (wrap) wrap.classList.remove('wd-cart-consent--error');
  }

  function syncButton(ctas) {
    if (!ctas) return;
    var btn = ctas.querySelector('.cart__checkout-button, button[name="checkout"]');
    if (!btn) return;
    var empty = btn.hasAttribute('data-wd-cart-empty');
    var ok = consentCheckedIn(ctas) && !empty;
    btn.disabled = !ok;
    btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
    if (ok) clearHint(ctas);
  }

  function syncAll() {
    var blocks = document.querySelectorAll('[data-wd-cart-consent]');
    for (var i = 0; i < blocks.length; i++) {
      syncButton(findCtas(blocks[i]));
    }
  }

  function applyStoredToInputs() {
    var on = getStored();
    var inputs = document.querySelectorAll('[data-wd-cart-consent-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked !== on) inputs[i].checked = on;
    }
    syncAll();
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyStoredToInputs, 40);
  }

  function onConsentChange(input) {
    var ctas = findCtas(input);
    setStored(!!input.checked);
    var inputs = document.querySelectorAll('[data-wd-cart-consent-input]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i] !== input) inputs[i].checked = input.checked;
    }
    if (input.checked) clearHint(ctas);
    syncAll();
  }

  function blockIfNeeded(event, ctas) {
    var scope = ctas || findCtas(event.target);
    var ok = scope ? consentCheckedIn(scope) : anyConsentChecked();
    if (ok) return false;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    showHint(scope);
    var input = (scope || document).querySelector('[data-wd-cart-consent-input]');
    if (input && typeof input.focus === 'function') {
      try {
        input.focus({ preventScroll: false });
      } catch (e) {
        input.focus();
      }
    }
    return true;
  }

  document.addEventListener(
    'change',
    function (event) {
      var t = event.target;
      if (!t || !t.matches || !t.matches('[data-wd-cart-consent-input]')) return;
      onConsentChange(t);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var btn =
        event.target &&
        event.target.closest &&
        event.target.closest('.cart__checkout-button, button[name="checkout"][data-wd-checkout-gated], button[name="checkout"]');
      if (btn && document.querySelector('[data-wd-cart-consent-input]')) {
        blockIfNeeded(event, findCtas(btn));
        return;
      }

      var link = event.target && event.target.closest && event.target.closest('a[href]');
      if (!link) return;
      if (!isCheckoutPath(link.getAttribute('href'))) return;
      if (!document.querySelector('[data-wd-cart-consent-input]')) return;
      blockIfNeeded(event, findCtas(link) || document.querySelector('.cart__ctas'));
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches) return;
      if (!form.matches('form.cart-form, form#cart-form')) return;
      if (!document.querySelector('[data-wd-cart-consent-input]')) return;

      var submitter = event.submitter;
      if (submitter && submitter.name && submitter.name !== 'checkout') return;
      if (submitter && submitter.name !== 'checkout' && !submitter.classList.contains('cart__checkout-button')) return;
      if (!submitter) return;

      blockIfNeeded(event, findCtas(submitter) || document.querySelector('.cart__ctas'));
    },
    true
  );

  document.addEventListener('cart:update', scheduleApply);

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (!m.addedNodes || !m.addedNodes.length) continue;
      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (node.nodeType !== 1) continue;
        if (
          node.matches?.('[data-wd-cart-consent], .cart__ctas, .cart-drawer, .cart-summary') ||
          node.querySelector?.('[data-wd-cart-consent-input], .cart__checkout-button')
        ) {
          scheduleApply();
          return;
        }
      }
    }
  });

  function start() {
    applyStoredToInputs();
    if (document.body) {
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
